export function count<T>(arr: T[], item: T) {
  return arr.filter((i) => i === item).length
}

/**
 * Deduplicates an array, returning a new array with no duplicates, where
 * duplicates are determined by reference equality.
 */
export function unique<T>(arr: T[]) {
  return [...new Set(arr)]
}

/**
 * Returns true if the two arrays have the same elements, regardless of order.
 *
 * @param a - The first array.
 * @param b - The second array.
 * @param predicate - A function that returns true if the two elements are equal.
 * @returns true if the two arrays have the same elements, regardless of order.
 */
export function sameElements<T>(
  a: T[],
  b: T[],
  predicate: (a: T, b: T) => boolean = (a, b) => a === b,
) {
  return a.length === b.length && a.every((value) => b.some((bValue) => predicate(value, bValue)))
}
